<template>
  <div class="m-0 dbozone-font bg-olympus1000" :class="`${lang}-font`">
    <div class="container d-flex flex-column justify-content-center">

      <div class="d-flex pt-5 justify-content-center align-items-center">
        <h5 class="game-title" :class="`-${lang} -olympus1000`">{{ $t('olympus1000.name') }}</h5>
      </div>

      <div class="d-flex pt-4 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} -olympus1000`">{{ $t('olympus1000.paytable') }}</h5>
      </div>

      <div class="d-flex p-4 justify-content-center align-items-center">
        <h5 class="sub-text-gray text-des" :class="`-${lang} -olympus1000`">{{ $t('olympus1000.paytable-des') }}</h5>
      </div>

      <div class="grid-container">
        <div v-for="(symbol, index) in sortedSymbols" :key="symbol.id" class="grid-item">

          <img :src="symbol.image" class="symbol-image" alt="symbol" />

          <div class="payouts">
            <div v-for="key in getSortedPayoutKeys(symbol)" :key="key" class="payout-row">
              <span class="sub-text-gray-payout" :style="getDynamicMargin(symbol.id)">
                <template v-if="key === 4 && index > 0">
                  &nbsp;&nbsp;&nbsp;&nbsp;{{ symbol.payouts[key].title }}&nbsp;&nbsp;|
                </template>
                <template v-else>
                  {{ symbol.payouts[key].title }}&nbsp;&nbsp;|
                </template>
              </span>

              <span class="sub-text-payout">{{ symbol.payouts[key].pay }}</span>
            </div>
          </div>

        </div>
      </div>

      <div class="d-flex pt-4 pb-4 justify-content-center align-items-center">
        <h5 class="text-title adjustment-text" :class="`-${lang} -olympus1000`">{{ $t('olympus1000.adjustment') }}</h5>
      </div>

      <div class="d-flex p-4 justify-content-center align-items-center">
        <div>
          <h5 class="sub-text-gray text-des" :class="`-${lang} -olympus1000`">{{ $t('olympus1000.adjustment-des') }}
          </h5>
          <div>
            <span class="m-0 sub-text ">{{ $t('olympus1000.note') }}</span>
            <span class="m-0 sub-text-gray ">{{ $t('olympus1000.note-des1') }}</span>
            <span class="m-0 sub-text-gray ">{{ $t('olympus1000.note-des2') }}</span>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-center align-items-center pt-4">
        <span>
          <h5 class="text-title" :class="`-${lang} -olympus1000`">{{ $t('olympus1000.gamefeature') }}</h5>
          <h5 class="text-title" :class="`-${lang} -olympus1000`">{{ $t('olympus1000.cascadingWin') }}</h5>
        </span>
      </div>

      <div class="d-flex p-4 justify-content-center align-items-center">
        <div>
          <h5 class="sub-text-gray text-des" :class="`-${lang} -olympus1000`">{{ $t('olympus1000.gamefeature-des') }}
          </h5>
        </div>
      </div>

      <div class="d-flex pt-4 pb-4 justify-content-center align-items-center">
        <h5 class="text-title adjustment-text" :class="`-${lang} -olympus1000`">{{ $t('olympus1000.multipliers-symbol')
          }}</h5>
      </div>

      <div class="d-flex p-4 justify-content-center align-items-center">
        <div>
          <span>
            <h5 class="sub-text-gray text-des" :class="`-${lang} -olympus1000`">{{
              $t('olympus1000.multipliers-symbol-des1') }}
            </h5>
            <h5 class="sub-text-gray text-des" :class="`-${lang} -olympus1000`">{{
              $t('olympus1000.multipliers-symbol-des2') }}
            </h5>
          </span>

        </div>
      </div>

      <div class="d-flex pt-4 justify-content-center align-items-center">
        <img :src="require(`../../assets/ruleGames/olympus1000/multiply_green.png`)" alt="multiply"
          class="multiplier-image" />
      </div>

      <div class="d-flex p-4 justify-content-left align-items-left">
        <div>
          <span>
            <h5 class="sub-text-gray text-des" :class="`-${lang} -olympus1000`">{{
              $t('olympus1000.multipliers-symbol-green1') }}
            </h5>
            <h5 class="sub-text-gray text-des" :class="`-${lang} -olympus1000`">{{
              $t('olympus1000.multipliers-symbol-green2') }}
            </h5>
          </span>
        </div>
      </div>

      <div class="d-flex pt-4 justify-content-center align-items-center">
        <img :src="require(`../../assets/ruleGames/olympus1000/multiply_blue.png`)" alt="multiply"
          class="multiplier-image" />
      </div>

      <div class="d-flex p-4 justify-content-left align-items-left">
        <div>
          <span>
            <h5 class="sub-text-gray text-des" :class="`-${lang} -olympus1000`">{{
              $t('olympus1000.multipliers-symbol-blue1') }}
            </h5>
            <h5 class="sub-text-gray text-des" :class="`-${lang} -olympus1000`">{{
              $t('olympus1000.multipliers-symbol-blue2') }}
            </h5>
          </span>
        </div>
      </div>

      <div class="d-flex pt-4 justify-content-center align-items-center">
        <img :src="require(`../../assets/ruleGames/olympus1000/multiply_purple.png`)" alt="multiply"
          class="multiplier-image" />
      </div>

      <div class="d-flex p-4 justify-content-left align-items-left">
        <div>
          <span>
            <h5 class="sub-text-gray text-des" :class="`-${lang} -olympus1000`">{{
              $t('olympus1000.multipliers-symbol-purple1') }}
            </h5>
            <h5 class="sub-text-gray text-des" :class="`-${lang} -olympus1000`">{{
              $t('olympus1000.multipliers-symbol-purple2') }}
            </h5>
          </span>
        </div>
      </div>

      <div class="d-flex pt-4 justify-content-center align-items-center">
        <img :src="require(`../../assets/ruleGames/olympus1000/multiply_red.png`)" alt="multiply"
          class="multiplier-image" />
      </div>

      <div class="d-flex p-4 justify-content-left align-items-left">
        <div>
          <span>
            <h5 class="sub-text-gray text-des" :class="`-${lang} -olympus1000`">{{
              $t('olympus1000.multipliers-symbol-red1') }}
            </h5>
            <h5 class="sub-text-gray text-des" :class="`-${lang} -olympus1000`">{{
              $t('olympus1000.multipliers-symbol-red2') }}
            </h5>
          </span>
        </div>
      </div>

      <div class="d-flex pt-4 justify-content-center align-items-center">
        <img :src="require(`../../assets/ruleGames/olympus1000/multiply_white.png`)" alt="multiply"
          class="multiplier-image" />
      </div>

      <div class="d-flex p-4 justify-content-left align-items-left">
        <div>
          <span>
            <h5 class="sub-text-gray text-des" :class="`-${lang} -olympus1000`">{{
              $t('olympus1000.multipliers-symbol-white1') }}
            </h5>
            <h5 class="sub-text-gray text-des" :class="`-${lang} -olympus1000`">{{
              $t('olympus1000.multipliers-symbol-white2') }}
            </h5>
          </span>
        </div>
      </div>

      <div class="d-flex pt-4 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} -olympus1000`">{{ $t('olympus1000.freespin') }}</h5>
      </div>

      <div class="d-flex justify-content-center align-items-center pt-4">
        <img :src="require(`../../assets/ruleGames/olympus1000/slotmachine.png`)" alt="slotmachine"
          class="slotmachine-image" />
      </div>

      <div class="symbol-content pt-4">
        <span>
          <ul v-for="(li, index) in 3" :key="index" class="symbol-info">
            <li class="sub-text-list-gray">{{ $t(`olympus1000.freespin-des${index + 1}`) }}</li>
          </ul>
        </span>
      </div>

      <div class="d-flex pt-4 pb-4 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} -olympus1000`">{{ $t('olympus1000.featurebuy') }}</h5>
      </div>

      <div class="d-flex justify-content-center align-items-center">
        <img :src="require(`../../assets/ruleGames/olympus1000/feature_buy_${imgLang}.png`)" alt="feature-buy"
          class="feature-buy-image" />
      </div>

      <div class="d-flex p-4 justify-content-center align-items-center">
        <div>
          <h5 class="sub-text-gray text-des" :class="`-${lang} -olympus1000`">{{ $t('olympus1000.featurebuy-des') }}
          </h5>
        </div>
      </div>

      <div class="d-flex pt-4 pb-4 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} -olympus1000`">{{ $t('olympus1000.gamerule') }}</h5>
      </div>

      <div class="d-flex p-4 justify-content-left align-items-left">
        <h5 class="sub-text-gray text-des" :class="`-${lang} -olympus1000`">{{ $t('olympus1000.text-rule1') }}</h5>
      </div>

      <div class="d-flex justify-content-center align-items-center">
        <img :src="require(`../../assets/ruleGames/olympus1000/slotmachine_multiplier.png`)" alt="slotmachine"
          class="slotmachine-image" />
      </div>

      <div class="d-flex p-4 justify-content-left align-items-left">
        <span>
          <li class="sub-text-gray" :class="`-${lang} -olympus1000`">
            {{ $t('olympus1000.min-bet') }}
            {{ currencyFormatterWithSymbol(betMinMax[0]) }}</li>
          <li class="sub-text-gray" :class="`-${lang} -olympus1000`">
            {{ $t('olympus1000.max-bet') }}
            {{ currencyFormatterWithSymbol(betMinMax[1]) }}
          </li>
          <li class="sub-text-gray" :class="`-${lang} -olympus1000`">
            {{ $t('olympus1000.game-rule1-1') }}
            {{ baseBet }}
            {{ $t('olympus1000.game-rule1-2') }}
          </li>
          <li class="sub-text-gray" :class="`-${lang} -olympus1000`">
            {{ $t('olympus1000.game-rule2-1') }}
            {{ currencyFormatterWithSymbol(betMinMax[0]) }}
            {{ $t('olympus1000.to') }}
            {{ currencyFormatterWithSymbol(betMinMax[1]) }}
            {{ $t('olympus1000.game-rule2-2') }}</li>
          <li class="sub-text-gray" :class="`-${lang} -olympus1000`">
            {{ $t('olympus1000.game-rule3') }}
            {{ currency + `(` + formattedCurrency + `)` }}
          </li>
          <li v-for="(li, index) in 6" :key="index" class="sub-text-gray" :class="`-${lang} -olympus1000`">
            {{ $t(`olympus1000.game-rule${index + 4}`) }}
          </li>
        </span>
      </div>

      <div class="d-flex pt-2 pb-4 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} -olympus1000`">{{ $t('olympus1000.round') }}</h5>
      </div>

      <div class="d-flex p-4 justify-content-left align-items-left">
        <span>
          <h5 class="sub-text-gray text-des" :class="`-${lang} -olympus1000`">{{ $t('olympus1000.round-des') }}</h5>
          <span v-for="(li, index) in 12" :key="index">
            <div
              v-if="index + 1 === 1 || index + 1 === 2 || index + 1 === 3 || index + 1 === 4 || index + 1 === 5 || index + 1 === 6 || index + 1 === 7">
              <span class="pb-2 [t-2 sub-text" :class="`-${lang} -olympus1000`">
                {{ $t(`olympus1000.round-title${index + 1}`) }}
                <span class="sub-text-gray" :class="`-${lang} -olympus1000`">{{ $t(`olympus1000.round-des${index + 1}`)
                  }}</span>
                <ul>
                  <li v-if="index + 1 === 5" class="sub-text-gray" :class="`-${lang} -olympus1000`">{{
                    $t(`olympus1000.round-des${index + 2}`) }}</li>
                  <li v-if="index + 1 === 5" class="sub-text-gray" :class="`-${lang} -olympus1000`">{{
                    $t(`olympus1000.round-des${index + 3}`) }}</li>
                  <li v-if="index + 1 === 5" class="sub-text-gray" :class="`-${lang} -olympus1000`">{{
                    $t(`olympus1000.round-des${index + 4}`) }}</li>
                  <li v-if="index + 1 === 6" class="sub-text-gray" :class="`-${lang} -olympus1000`">{{
                    $t(`olympus1000.round-des${index + 5}`) }}</li>
                  <li v-if="index + 1 === 6" class="sub-text-gray" :class="`-${lang} -olympus1000`">{{
                    $t(`olympus1000.round-des${index + 6}`) }}</li>
                  <li v-if="index + 1 === 6" class="sub-text-gray" :class="`-${lang} -olympus1000`">{{
                    $t(`olympus1000.round-des${index + 7}`) }}</li>
                </ul>
              </span>
            </div>
          </span>
        </span>

      </div>

      <div class="d-flex pt-4 pb-4 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} -olympus1000`">{{ $t('main-game.title') }}</h5>
      </div>

      <table class="control-table">
        <tr>
          <td><img :src="require(`../../assets/ruleGames/olympus1000/spin_btn.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.spin-button') }}</h3>
            <li v-for="(li, index) in 3" :key="index" class="sub-text-gray">
              {{ $t(`main-game.spin-button-des${index + 1}`) }}
            </li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/olympus1000/autospin_btn.png`)" alt="icon"
              class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.auto_spin-button') }}</h3>
            <li v-for="(li, index) in 2" :key="index" class="sub-text-gray">
              {{ $t(`main-game.auto-spin-button-des${index + 1}`) }}
            </li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/olympus1000/stop_btn.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <li v-for="(li, index) in 2" :key="index" class="sub-text-gray">
              {{ $t(`main-game.auto-spin-round-des${index + 1}`) }}
            </li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/olympus1000/betsize_btn.png`)" alt="icon"
              class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.bet-option-button') }}</h3>
            <li class="sub-text-gray">{{ $t('main-game.bet-option-button-des1') }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/olympus1000/turbo_on.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.turbo-button') }}</h3>
            <li class="sub-text-gray">{{ $t('main-game.turbo-button-des1') }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/olympus1000/info_btn.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.gamerule-button') }}</h3>
            <li class="sub-text-gray">{{ $t('main-game.gamerule-button-des1') }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/olympus1000/additional_btn.png`)" alt="icon"
              class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.additional-menu') }}</h3>
            <li class="sub-text-gray">{{ $t('main-game.additional-menu-des1') }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/olympus1000/setting_btn.png`)" alt="icon"
              class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.settings') }}</h3>
            <li class="sub-text-gray">{{ $t('main-game.settings-des1') }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/olympus1000/history_btn.png`)" alt="icon"
              class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.history-button') }}</h3>
            <li class="sub-text-gray">{{ $t('main-game.history-button-des1') }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/olympus1000/home_btn.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.back') }}</h3>
            <li class="sub-text-gray">{{ $t('main-game.back-des1') }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/olympus1000/icon_wallet.png`)" alt="icon"
              class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.wallet-balance-button') }}</h3>
            <li v-for="(li, index) in 2" :key="index" class="sub-text-gray">{{
              $t(`main-game.wallet-balance-button-des${index + 1}`) }} </li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/olympus1000/icon_refresh.png`)" alt="icon"
              class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.refresh-balance-button') }}</h3>
            <li class="sub-text-gray">{{ $t('main-game.refresh-balance-button-des1') }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/olympus1000/icon_bet.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.bet-amount-button') }}</h3>
            <li v-for="(li, index) in 3" :key="index" class="sub-text-gray">{{
              $t(`main-game.bet-amount-button-des${index + 1}`) }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/olympus1000/icon_win.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.winnings-button') }}</h3>
            <li v-for="(li, index) in 2" :key="index" class="sub-text-gray">{{ $t(`main-game.winnings-button-des${index
              + 1}`) }}</li>
          </td>
        </tr>
      </table>

      <div class="d-flex pt-5 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} -naturalace`">{{ $t('naturalace.additional') }}</h5>
      </div>

      <div class="d-flex p-4 justify-content-center align-items-center">
        <u>
          <li class="sub-text-gray text-des" :class="`-${lang} -naturalace`">{{ $t('naturalace.additional-des1') }}
          </li>
          <li class="sub-text-gray text-des" :class="`-${lang} -naturalace`">{{ $t('naturalace.additional-des2') }}
          </li>
        </u>
      </div>

      <div class="p-3"></div>

    </div>
  </div>
</template>

<script>

export default {
  name: 'rule-olympus1000',
  props: {
    data: Object,
    lang: String,
    imgLang: String,
    betMinMax: Array,
    currentBet: Number,
    featureBuyMaximum: Number,
    featureBuyMultiplier: Number,
    currency: String,
    isShowCurrencySymbol: Boolean,
  },
  data() {
    return {
      baseBet: this.data.config.baseBet,
      betLevel: this.data.config.betLevel,
      betSize: this.data.config.betSize,
      paytable: this.data.config.payTable,
      symbols: [],
    }
  },
  mounted() {
    this.generateSymbols();
  },
  computed: {
    formattedCurrency() {
      return this.$options.filters.currencySymbol(this.currency);
    },
    sortedSymbols() {
      return [...this.symbols].sort((a, b) => b.id - a.id); // clone then sort
    }
  },
  methods: {
    currencyFormatterWithSymbol(val) {
      if (this.isShowCurrencySymbol === false) {
        this.currency = '';
      }
      return this.$options.filters.currencyFormatterWithSymbol(val, this.currency);
    },
    decimalFormat(value) {
      value = Math.round((value + Number.EPSILON) * 1000) / 1000;
      return value.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 3 });
    },
    generateSymbols() {
      const symbolsData = [];
      for (let i = 0; i < 10; i++) {
        const id = i;
        symbolsData.push({
          id: id,
          image: require(`../../assets/resultGame/olympus1000/1/symbol_${id}.png`),
          payouts: {
            4: {
              title: id === 9 ? '4' : `8-9`,
              pay: this.decimalFormat(this.currentBet * this.data.config.payTable[id][id === 9 ? 3 : 8] / this.baseBet),
            },
            5: {
              title: id === 9 ? '5' : '10-11',
              pay: this.decimalFormat(this.currentBet * this.data.config.payTable[id][id === 9 ? 4 : 10] / this.baseBet),
            },
            6: {
              title: id === 9 ? '6' : '12-30',
              pay: this.decimalFormat(this.currentBet * this.data.config.payTable[id][id === 9 ? 5 : 11] / this.baseBet)
            }
          },
        });
      }
      this.symbols = symbolsData;
    },
    getDynamicMargin(id) {
      const maxLength = this.decimalFormat(this.currentBet * this.data.config.payTable[id][id === 9 ? 5 : 11] / this.baseBet).length;
      let magin = 'calc(0%)'

      if (maxLength < 5) {
        magin = id === 9 ? 'calc(40%)' : 'calc(25%)'
      } else if (maxLength === 5) {
        magin = id === 9 ? 'calc(35%)' : 'calc(20%)'
      } else if (maxLength > 5 && maxLength < 7) {
        magin = id === 9 ? 'calc(30%)' : 'calc(20%)'
      } else if (maxLength >= 7 && maxLength < 9) {
        magin = id === 9 ? 'calc(27%)' : 'calc(19%)'
      } else if (maxLength >= 9 && maxLength < 11) {
        magin = id === 9 ? 'calc(25%)' : 'calc(15%)'
      } else {
        magin = id === 9 ? 'calc(20%)' : 'calc(10%)'
      }

      return {
        marginLeft: magin,
      };
    },
    getSortedPayoutKeys(symbol) {
      return Object.keys(symbol.payouts)
        .map(Number)
        .sort((a, b) => b - a);
    }
  }
}
</script>

<style scoped>
.grid-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 40px;
  padding: 40px;
  background-color: #202020;
  border-radius: 20px;
  margin: 20px;
}

.grid-item {
  text-align: center;
  padding-top: 10%;
}

.symbol-image {
  width: 60%;
  height: auto;
}

.payouts {
  margin-top: 10px;
}

.payout-row {
  display: flex;
  justify-content: left;
  align-items: left;
}

.symbol-container {
  margin: 5%;
  padding: 5%;
  background-color: #2d2d2d;
  color: white;
  border-radius: 10px;
}

.symbol-content {
  display: flex;
  align-items: center;
}

.special-symbol-image {
  width: 25%;
  margin-right: 20px;
}

.symbol-info {
  padding-left: 40px;
}

.symbol-info li {
  font-size: 3vw;
}

h2 {
  font-size: 20px;
  margin-bottom: 20px;
  font-weight: bold;
}

.wild-comming-image {
  width: 70%;
  height: auto;
}

.multiplier-image {
  /* width: 95%; */
  height: auto;
}

.freespin-feature-image {
  width: 60%;
  height: auto;
}

.feature-buy-image {
  width: 40%;
  height: auto;
}

.win-line-image {
  width: 70%;
  height: auto;
}

.win-line-container {
  padding: 20px;
  background-color: #2d2d2d;
  color: white;
  border-radius: 10px;
  max-width: 600px;
  margin: auto;
  font-family: 'Arial', sans-serif;
}

h2 {
  font-size: 24px;
  margin-bottom: 10px;
}

.win-line-images {
  display: flex;
  justify-content: space-around;
  margin: 20px 0;
}

.image-container {
  position: relative;
}

.check {
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 24px;
  color: green;
}

.cross {
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 24px;
  color: red;
}

.win-description,
.example,
.extra-info {
  margin: 10px 0;
  font-size: 14px;
}

.payout-table {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 0;
}

.payout-info ul {
  list-style: none;
  padding: 0;
}

.total-win {
  text-align: center;
}

.example-win {
  font-size: 3vw;
  color: #f39c12;
}

.extra-info {
  font-size: 12px;
  margin-top: 20px;
}

.slotmachine-image {
  width: 90%;
  height: auto;
}
</style>

<style>
.bg-olympus1000 {
  background: #282828;
}

.game-title {
  font-size: 3vw;
  color: white;
}

.text-title {
  color: #fff;
  font-size: 4vw;
  text-align: center;
}

.sub-text-gray {
  color: #fff;
  opacity: 0.7;
  font-size: 3vw;
}

.sub-text-gray-payout {
  color: #fff;
  opacity: 0.7;
  font-size: 3vw;
  margin-left: calc(30%);
}

.sub-text-payout {
  color: #fff;
  font-size: 3vw;
  margin-left: 5%;
  text-align: left;
}

.sub-text-list-gray {
  color: #fff;
  opacity: 0.7;
  font-size: 3vw;
  margin: 0 auto;
}

.sub-text {
  color: #fff;
  font-size: 3vw;
  /* margin: 0 8px; */
}

.sub-bg {
  background: #202020;
  border-radius: 30px;
}

.control-table {
  width: 100%;
  border-collapse: collapse;
}

.control-table td {
  border: 3px solid #fff;
  padding: 30px;
  vertical-align: middle;
}

.control-table h3 {
  margin-bottom: 30px;
  font-size: 3vw;
  color: #fff;
}

.control-table p {
  margin: 5px 0 0 0;
  font-size: 3vw;
}

.control-icon {
  width: 150px;
  height: 150px;
}

.adjustment-text {
  padding-left: 20%;
  padding-right: 20%;
}

.text-des {
  line-height: 1.5;
}

@media (min-width: 576px) {

  .container,
  .container-sm,
  .container-md {
    max-width: 720px;
  }
}

@media (min-width: 768px) {

  .container,
  .container-sm,
  .container-md {
    max-width: 900px;
  }
}

@media (min-width: 1024px) {

  .container,
  .container-sm,
  .container-md {
    max-width: 1520px;
  }
}
</style>